import classnames from "classnames";
import React, { FC, ReactNode, useState } from "react";
import { FaStar } from "react-icons/fa";
import { FaRegStar } from "react-icons/fa";

interface ServicesListItemProps {
  children: ReactNode;
  isFavorite: boolean;
  path: string;
  handleFavorites: () => void;
}

export const ServicesListItem: FC<ServicesListItemProps> = ({
  children,
  isFavorite,
  path,
  handleFavorites,
}) => {
  const [selected, setSelected] = useState(isFavorite);

  return (
    <a href={path} target="_top" aria-disabled="false" className="flex items-start group hover:bg-controlBackground border-gray-500/0 hover:border-gray-500 border-2 pr-2 pt-2 pb-2 pl-2 mb-1 rounded-lg">
      <button
        className={classnames(
          "group-hover:visible transition ease-in-out delay-50 hover:brightness-125",
          {
            "text-link": selected,
            "text-slate-600": !selected,
            invisible: !selected,
          },
        )}
        onClick={(event) => {
          event.preventDefault();
          // timeout is needed to perform this click action after bothe events in ServicesMenu.tsx
          setTimeout(() => {
            setSelected((prev) => !prev);
            handleFavorites();
          }, 10);
        }}
      >
        {selected ? (
          <FaStar size={24} />
        ) : (
          <FaRegStar size={24} />
        )}
      </button>
      <span className="pl-2">
        {children}
      </span>
    </a>
  );
};
